import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { Text } from '@sketch/components'
import { CollapsibleInspectorSection } from '../../components'
import { useHandleCopyValue } from '@sketch/modules-common'
import { ReactComponent as RectanglesIcon } from '@sketch/icons/rectangles-2-17'

const ContentContainer = styled(Text.Div).attrs({
  textStyle: 'copy.secondary.standard.D',
})`
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  border: 1px dashed ${({ theme }) => theme.colors.border.A};
  border-radius: 4px;
  display: block;
  padding: 8px 12px;
  margin: 12px 20px 0;
`

interface ContentProps {
  children: string
  style?: CSSProperties
}

export const TextContent: React.FCC<ContentProps> = ({
  children,
  ...props
}) => {
  const { handleCopyValue, copyTooltipText } = useHandleCopyValue(
    children ?? ''
  )

  return (
    <CollapsibleInspectorSection
      identifier="text-content"
      title="Content"
      noPadding
      actions={[
        {
          icon: <RectanglesIcon width={17} height={17} />,
          tooltipText: copyTooltipText,
          onClick: handleCopyValue,
        },
      ]}
      data-testid="inspector-sidebar-content"
    >
      <ContentContainer data-testid="content-container" {...props}>
        {children.split(/\r?\n/).map((text, index) => (
          <span key={index}>
            {text}
            <br />
          </span>
        ))}
      </ContentContainer>
    </CollapsibleInspectorSection>
  )
}
